<div class="snackbar-row">
  <div class="snackbar-message">{{ data.message }}</div>

  <div class="snackbar-actions">
    <button *ngIf="data.primaryButtonLabel" mat-flat-button color="primary" (click)="handlePrimary()">
      {{ data.primaryButtonLabel }}
    </button>

    <button *ngIf="data.secondaryButtonLabel" mat-button (click)="dismiss()">
      {{ data.secondaryButtonLabel }}
    </button>
  </div>
</div>
